import React, { useState } from 'react';

const useTable = () => {
    const [sortOrder, setSortOrder] = useState('');
    const [sortDir, setSortDir] = useState('');
    const caretUp = <span>&#9650;</span>;
    const caretDown = <span>&#9660;</span>;
    const sortDirection = sortDir === 'asc' ? caretUp : caretDown;

    const onSortChange = (field) => {
        const sortDirection = sortOrder === field && sortDir === "asc" ? "desc" : "asc";
        setSortOrder(field);
        setSortDir(sortDirection);
    }
    const doSort = (data) => {
        if (!sortOrder) return data;

        if (sortDir === 'asc')
            return data.sort((a, b) => 
                a[sortOrder].toString().localeCompare(b[sortOrder].toString(), undefined, { numeric: true }))
        else
            return data.sort((a, b) => 
                b[sortOrder].toString().localeCompare(a[sortOrder].toString(), undefined, { numeric: true }))
    }
    return {
        onSortChange,
        doSort,
        sortOrder,
        sortDirection
    }
}

export default useTable;